/* "Not now" on the save-your-recovery-codes prompt lasts for THIS sign-in only.
 *
 * A member with two-factor authentication on and no recovery codes is asked on
 * arrival, every time they sign in, until a set exists: the codes are the way back
 * in without a 72-hour reset, and a member who has never generated them has no
 * such way. Like the billing prompt (utils/billingPromptDismissal.ts) the answer
 * lives in sessionStorage — gone when the tab closes — and AuthContext clears it
 * whenever a session starts or ends.
 *
 * Storage can be unavailable (private windows, blocked site data). Every access is
 * guarded, and the fallback is to ask again — never to break the portal. */
const KEY = 'incrypt_recovery_codes_prompt_dismissed';

export const recoveryCodesPromptDismissed = (): boolean => {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const dismissRecoveryCodesPrompt = (): void => {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    /* they will simply be asked again on the next page load */
  }
};

export const resetRecoveryCodesPromptDismissal = (): void => {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
};
